<div class="parent" *ngIf="data?.length">
    <div class="grid" [ngStyle]="{'grid-template-columns': (isAdmin && !editable? 'repeat(3, 1fr)' : 'repeat(1, 1fr)')}">
        <span class="columnHeader" *ngFor="let t of columns; let i = index">
              {{ t }}
        </span>
    </div>
    <div class="grid gridRow" [ngStyle]="{'grid-template-columns': (isAdmin && !editable? 'repeat(3, 1fr)' : 'repeat(1, 1fr)')}" *ngFor="let k of data">
        <span class="pertinent linkToQM" matTooltip="Click to view this specification" [matTooltipShowDelay]="tooltipDelay" (click)="clickTheLink(k)">
          <div class="qmName" style="display: inline-block; text-align: left;">
            {{ k.itemName }}
          </div>
          <div style="display:inline-block; text-align: right;">
            <i *ngIf="editable && isAdmin" (click)="removeItem(k)" class="fas fa-trash ms-1" title="Remove entry" style="cursor: pointer;"></i>
          </div>
        </span>
        <span *ngIf="!editable && isAdmin" style="text-align: left;">
          {{ k.createdDateTime | date:'medium' }}
        </span>
        <span *ngIf="!editable && isAdmin" style="text-align: left;">
          {{ k.createdByUser }}
        </span>
    </div>
    <!-- <div class="grid gridRow" style="height: 30px;" *ngIf='(!data || data?.length === 0) && !editable'>
       No Quartermaster Manuals found
    </div> -->

</div>
<div class="recordCount" *ngIf="!editable && data?.length">
    {{ data ? data.length : 0}} contract item record(s)
</div>
<div class="recordCount" *ngIf="!data?.length">
  We don't have any Contract Items for this record.
</div>